import { useStore, useStoreMap } from 'effector-react'
import { balanceModel } from '~/entities/Balance'
import { $selectedPayCard, payout, payoutFx } from '~/entities/Balance/model'
import { CURRENCY } from '~/shared/config/constants'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { PayCardContent, PayCardWrapper } from '~/shared/ui/PayCard'
import {
  DetailAmountTitle,
  DetailBlock,
  DetailItemTitle,
  Title,
} from './styled'

type ConfirmWithdrawalDrawerProps = {
  isShow: boolean
  onClose: () => void
}

const getSum = (value: unknown) =>
  typeof value === 'number' ? value.toLocaleString() : '-'

export function ConfirmWithdrawalDrawer({
  isShow,
  onClose,
}: ConfirmWithdrawalDrawerProps) {
  const selectedPayCard = useStoreMap($selectedPayCard, (payCard) =>
    payCard?.getAttributes(),
  )
  const commission = useStore(balanceModel.$commission)

  const isSubmitting = useStore(payoutFx.pending)

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <div style={{ textAlign: 'center', marginBottom: '44px' }}>
        <div style={{ fontSize: '12px' }}>Итоговая сумма для вывода</div>
        <div
          style={{ fontSize: '32px', fontWeight: '500' }}
          data-testid='confirm-withdrawal-amount-total'
        >
          {getSum(commission?.amountTotal)} {CURRENCY}
        </div>
      </div>

      <div style={{ fontSize: '16px', marginBottom: '16px' }}>Детали:</div>
      <DetailBlock style={{ marginBottom: '8px' }}>
        <DetailItemTitle>Сумма без комиссии</DetailItemTitle>
        <DetailAmountTitle data-testid='confirm-withdrawal-amount'>
          {getSum(commission?.amount)} {CURRENCY}
        </DetailAmountTitle>
      </DetailBlock>
      <DetailBlock style={{ marginBottom: '32px' }}>
        <DetailItemTitle>Комиссия</DetailItemTitle>
        <DetailAmountTitle data-testid='confirm-withdrawal-commission-amount'>
          {getSum(commission?.commissionAmount)} {CURRENCY}
        </DetailAmountTitle>
      </DetailBlock>

      <Title>Вывести на карту:</Title>
      <div
        style={{ marginBottom: '44px' }}
        data-testid='confirm-withdrawal-pay-card'
      >
        <PayCardWrapper>
          <PayCardContent
            cardNumber={selectedPayCard?.maskedNumber as string}
          />
        </PayCardWrapper>
      </div>
      <Button
        fullWidth
        variant='limeFlooded'
        size='large'
        onClick={() => payout()}
        loading={isSubmitting}
      >
        Подтвердить
      </Button>
    </DrawerComponent>
  )
}
